import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import { Row, Col } from 'react-bootstrap'
import Dashboard from '../pages/teacher/Dashboard'
import Profile from '../pages/teacher/Profile'
import ClassList from '../pages/teacher/classes/ClassList'
import ClassSession from '../pages/teacher/classes/ClassSession'
import GroupList from '../pages/teacher/groups/GroupList'
import StudentList from '../pages/teacher/students/StudentList'
import StudentCard from '../pages/teacher/students/StudentCard'
import EvaluationList from '../pages/teacher/evaluations/EvaluationList'
import ProgressView from '../pages/teacher/evaluations/ProgressView'
import TaskList from '../pages/teacher/tasks/TaskList'
import TaskDetail from '../pages/teacher/tasks/TaskDetail'
import MessageList from '../pages/teacher/communications/MessageList'
import CalendarView from '../pages/teacher/calendar/CalendarView'
import ScheduleView from '../pages/teacher/calendar/ScheduleView'
import SDOntimeLink from '../pages/teacher/employment/SDOntimeLink'
import Version from '../version'
import Menu from '../components/menus/Menu'
import Sidebar from '../components/menus/Sidebar'

export default function TeacherRouter() {

	return (
		<div className='contenido'>
			<Sidebar />
			<div className='content'>
				<Menu />
				<Routes>
					<Route path="/dashboard" element={<Dashboard />} />
					<Route path="/groups" element={<GroupList />} />
					<Route path="/classes" element={<ClassList />} />
					<Route path="/classes/session/:sessionId" element={<ClassSession />} />
					<Route path="/students" element={<StudentList />} />
					<Route path="/students/:studentId" element={<StudentCard />} />
					<Route path="/evaluations" element={<EvaluationList />} />
					<Route path="/evaluations/progress" element={<ProgressView />} />
					<Route path="/tasks" element={<TaskList />} />
					<Route path="/tasks/:taskId" element={<TaskDetail />} />
					<Route path="/communications" element={<MessageList />} />
					<Route path="/calendar" element={<CalendarView />} />
					<Route path="/schedule" element={<ScheduleView />} />
					<Route path="/employment" element={<SDOntimeLink />} />
					<Route path="/profile" element={<Profile />} />
					<Route path="*" element={<NotFoundPage />} />
				</Routes>
				<Row>
					<Col className='text-center my-3'>
						<Version />
					</Col>
				</Row>
			</div>
		</div>
	)
}
